<template>
  <div>
    <el-row>
      <classHoursTableContainer
        CustomTableArticle
        :columns="containerTableColumns"
        :serverUrl="containerServerUrl"
        :baseUrl="containerBaseUrl"
        :fromWhere="fromWhere"
        ref="TableContainer"
      >
        <!-- <template v-slot:tools>
          <router-link :to="containerBaseUrl + '/add'">
            <el-button type="primary" icon="el-icon-circle-plus-outline">增加学时信息</el-button>
          </router-link>
        </template>-->

        <template v-slot:filter>
          <template v-if="isAdmin || isRoleinfo.hasPer10001 || isRoleinfo.hasPer10003">
            <UnitCascader @onValueChanged="onUnitValueChanged"></UnitCascader>            
          </template>
          <template v-if="isAdmin || isRoleinfo.hasPer10001 || isRoleinfo.hasPer10002">
            <PartyOrgCascader @onValueChanged="onPartyValueChanged"></PartyOrgCascader>                        
          </template>
        </template>

        <!--  -->
        <template v-slot:table__footer__info>学时信息列表</template>
      </classHoursTableContainer>

      <!-- <el-row>
          <p class="paragraph-content-small grey asset"><i class="el-icon-info"></i> 当前列表项的显示顺序，即是网站相关项目的显示顺序。</p>
      </el-row>-->
    </el-row>
  </div>
</template>


<script>
import { classHoursTableContainer } from "@/core/table/";
import { UnitCascader, PartyOrgCascader } from "@/views/components/select";
import { BaseVue } from "@/mixin/index";

export default {
  name: "ExportHourUser",
  
  mixins: [BaseVue],
  
  components: {
    classHoursTableContainer,
    UnitCascader,
    PartyOrgCascader
  },
  
  data() {
    return {
      fromWhere: "userClassHours",
      containerBaseUrl: "/user",
      containerServerUrl: "/api/manager/userscheduling/hours"
    };
  },
  
  computed: {
    containerTableColumns() {
      if (this.isAdmin || this.isRoleinfo?.hasPer10001) {
        return [
          {
            prop: "name",
            label: "姓名",
            width: "200px",
          },
          {
            prop: "scoreCurrentYear",
            label: "当年学时",
            width: "100px",
          },
          {
            prop: "scoreLegancy",
            label: "历年学时",
            width: "100px",
          },
          {
            prop: "partyTitle",
            label: "所属党组织",
            width: "350px",
          },
          {
            prop: "unitTitle",
            label: "所属单位",
            width: "350px",
          },
        ];
      } else if (this.isRoleinfo?.hasPer10002) {
        return [
          {
            prop: "name",
            label: "姓名",
            width: "200px",
          },
          {
            prop: "scoreCurrentYear",
            label: "当年学时",
            width: "100px",
          },
          {
            prop: "scoreLegancy",
            label: "历年学时",
            width: "100px",
          },
          {
            prop: "partyTitle",
            label: "所属党组织",
            width: "350px",
          }
        ];
      } else if (this.isRoleinfo?.hasPer10003) {
        return [
          {
            prop: "name",
            label: "姓名",
            width: "200px",
          },
          {
            prop: "scoreCurrentYear",
            label: "当年学时",
            width: "100px",
          },
          {
            prop: "scoreLegancy",
            label: "历年学时",
            width: "100px",
          },
          {
            prop: "unitTitle",
            label: "所属单位",
            width: "350px",
          }
        ];
      }
      
      // 如果没有匹配的条件，返回空数组或默认值
      return [];
    }
  },
  
  methods: {
    onUnitValueChanged(data) {
      console.log("onUnitValueChanged", data);
      if (this.$refs.TableContainer && this.$refs.TableContainer.updateParams) {
        this.$refs.TableContainer.updateParams("units", data);
      }
    },
    
    onPartyValueChanged(data) {
      console.log("onPartyValueChanged", data);
      if (this.$refs.TableContainer && this.$refs.TableContainer.updateParams) {
        this.$refs.TableContainer.updateParams("partyids", data);
      }
    }
  },
  

  mounted() {
    console.log("isRoleinfo", this.isRoleinfo);   // 所有支部单位
    console.log("isAdmin", this.isAdmin);   // isadmin
    console.log("isRoleinfo.hasPer00001", this.isRoleinfo?.hasPer10001);   // 所有支部单位
    console.log("isRoleinfo.hasPer00002", this.isRoleinfo?.hasPer10002);   // 本支部
    console.log("isRoleinfo.hasPer00003", this.isRoleinfo?.hasPer10003);   // 本单位
  }
};
</script>

<style scoped>
</style>